import { render, staticRenderFns } from "./EntregaDestinoCard.vue?vue&type=template&id=1e4ac3b6"
import script from "./EntregaDestinoCard.vue?vue&type=script&lang=js"
export * from "./EntregaDestinoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports